import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import styles from "./profile-succcess.module.css";

const ProfileSuccess = (): ReactElement => {
    return (
        <div className={styles.wrap}>
            <div className={styles.iconBox}>
                <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                        d="M20 7L10 17L5 12"
                        stroke="currentColor"
                        strokeWidth="2.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>

            <div className={styles.content}>
                <div className={styles.eyebrow}>Регистрация завершена</div>
                <h3 className={styles.title}>Профиль отправлен на модерацию</h3>
                <p className={styles.text}>
                    Спасибо, анкета успешно создана. Сейчас мы проверим профиль и фотографии,
                    чтобы в сообществе было комфортно и безопасно.
                </p>
            </div>

            <div className={styles.card}>
                <div className={styles.cardTitle}>После одобрения вам откроются:</div>
                <ul className={styles.list}>
                    <li>поиск участников;</li>
                    <li>раздел «Свои» и мэтчи;</li>
                    <li>запись на мероприятия.</li>
                </ul>
            </div>

            <p className={styles.note}>
                Как только модерация завершится, мы отправим сообщение в Telegram.
            </p>

            <Link to="/events" className={styles.ok}>
                К событиям
            </Link>
        </div>
    );
};

export default ProfileSuccess;
